import { Client, StatusCode } from '../types/catalog'

export const generateMockClients = (): Client[] => {
  const clients: Client[] = []
  const baseNames = [
    'Grupo Alfa',
    'Industrias Beta',
    'Soluciones Gamma',
    'Tecnología Delta',
    'Servicios Omega',
    'Corporativo Sigma',
    'Empresa Zeta',
    'Comercial Épsilon',
    'Digital Lambda',
    'Innovación Kappa',
  ]
  const services = [
    'App Web',
    'Móvil iOS',
    'Móvil Android',
    'Pasarela API',
    'Procesador de Pagos',
    'Servicio de Auth',
    'Sincronización de Datos',
    'Proceso en Segundo Plano',
  ]

  for (let i = 1; i <= 25; i++) {
    const isInactive = Math.random() > 0.8
    const company = baseNames[Math.floor(Math.random() * baseNames.length)]
    const service = services[Math.floor(Math.random() * services.length)]

    const date = new Date()
    date.setDate(date.getDate() - Math.floor(Math.random() * 180))

    clients.push({
      id: `client-${i}`,
      clientCode: `CL-${i.toString().padStart(3, '0')}`,
      clientName: `${company} - ${service}`,
      description: `Integración principal para los servicios de ${service.toLowerCase()} de ${company}.`,
      status: isInactive ? 'inactive' : 'active',
      createdAt: date.toISOString(),
    })
  }

  return clients.sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  )
}

export const generateMockStatusCodes = (): StatusCode[] => {
  const baseDate = new Date()
  baseDate.setMonth(baseDate.getMonth() - 12)

  return [
    {
      id: 'sc-1',
      statusCode: 'SC-200',
      statusName: 'OK',
      description: 'Respuesta estándar para solicitudes exitosas.',
      color: 'green',
      createdAt: baseDate.toISOString(),
    },
    {
      id: 'sc-2',
      statusCode: 'SC-201',
      statusName: 'Creado',
      description:
        'La solicitud se ha completado y se ha creado un nuevo recurso.',
      color: 'green',
      createdAt: baseDate.toISOString(),
    },
    {
      id: 'sc-3',
      statusCode: 'SC-204',
      statusName: 'Sin Contenido',
      description:
        'El servidor procesó la solicitud correctamente pero no devuelve contenido.',
      color: 'green',
      createdAt: baseDate.toISOString(),
    },
    {
      id: 'sc-4',
      statusCode: 'SC-301',
      statusName: 'Movido Permanentemente',
      description:
        'Esta y todas las solicitudes futuras deben dirigirse a la URI indicada.',
      color: 'blue',
      createdAt: baseDate.toISOString(),
    },
    {
      id: 'sc-5',
      statusCode: 'SC-400',
      statusName: 'Solicitud Incorrecta',
      description:
        'El servidor no puede procesar la solicitud debido a un error aparente del cliente.',
      color: 'yellow',
      createdAt: baseDate.toISOString(),
    },
    {
      id: 'sc-6',
      statusCode: 'SC-401',
      statusName: 'No Autorizado',
      description:
        'Se requiere autenticación y esta ha fallado o no se ha proporcionado.',
      color: 'yellow',
      createdAt: baseDate.toISOString(),
    },
    {
      id: 'sc-7',
      statusCode: 'SC-403',
      statusName: 'Prohibido',
      description:
        'La solicitud es válida, pero el servidor rechaza la acción. El usuario podría no tener los permisos necesarios.',
      color: 'yellow',
      createdAt: baseDate.toISOString(),
    },
    {
      id: 'sc-8',
      statusCode: 'SC-404',
      statusName: 'No Encontrado',
      description:
        'El recurso solicitado no se pudo encontrar pero podría estar disponible en el futuro.',
      color: 'yellow',
      createdAt: baseDate.toISOString(),
    },
    {
      id: 'sc-9',
      statusCode: 'SC-500',
      statusName: 'Error Interno del Servidor',
      description:
        'Mensaje de error genérico cuando se encuentra una condición inesperada.',
      color: 'red',
      createdAt: baseDate.toISOString(),
    },
    {
      id: 'sc-10',
      statusCode: 'SC-502',
      statusName: 'Puerta de Enlace Incorrecta',
      description:
        'El servidor actuaba como puerta de enlace o proxy y recibió una respuesta inválida del servidor upstream.',
      color: 'red',
      createdAt: baseDate.toISOString(),
    },
    {
      id: 'sc-11',
      statusCode: 'SC-503',
      statusName: 'Servicio No Disponible',
      description:
        'El servidor no está disponible actualmente (por sobrecarga o mantenimiento).',
      color: 'red',
      createdAt: baseDate.toISOString(),
    },
  ]
}
